export default __webpack_public_path__ + "static/media/Bonus_60F.a046eda2.webm";